import React from "react";
import { Link } from "react-router-dom";
import logo from "assets/images/logo.svg";

function Footer() {
  return (
    <>
      <div className="container-fluid bg-blackCoco">
        <div className="row px-3 py-5">
          <div className="col-lg-3">
            <div className="footer-logo">
              <img src={logo} alt="" />
            </div>
            <div className="txt">
              <p className="text-white fs-18 fw-300 w-md-75 w-100">
                Borem ipsum dolor sit amet, consectetur adipiscing elit. ipsum
                dolor sit amet, consectetur
              </p>
            </div>
          </div>
          <div className="col-lg-3">
            <div className="footer-menu">
              <h6 className="fs-16 fw-500 hc">MENU</h6>
              <ul className="list-unstyled mt-3 text-white">
                <li>
                  <Link className="text-white" to="/">
                    Home
                  </Link>
                </li>
                {/* <li>Gym</li>
                <li>Contact Us</li> */}
              </ul>
            </div>
          </div>
          <div className="col-lg-3">
            <div className="footer-quick-links">
              <h6 className="fs-16 fw-500 hc">QUICK LINKS</h6>
              <ul className="list-unstyled mt-3 text-white">
                {/* <li>Log In</li> */}
                <li>
                  <Link className="text-white" to="/terms">
                    Terms And Condition
                  </Link>
                </li>
                <li>
                  <Link className="text-white" to="/policy">
                    Privacy Policy
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-3">
            <div className="footer-contact-info">
              <h6 className="fs-16 fw-500 hc">CONTACT INFO</h6>
              <br />
              <a
                href=""
                className="text-decoration-none text-white fw-300 w-75"
              >
                6589 Elgin St. Celina, Delaware 10299
              </a>
              <br />
              <a
                className="text-decoration-none text-white fs-16 fw-300 mt-5"
                href="mailto: info@elevatediron.com"
              >
                info@elevatediron.com
              </a>
            </div>
          </div>
        </div>
        <hr className="text-white w-100" />
        <div className="copyright-section text-center pt-2 pb-1">
          <p className="text-white fw-300">
            Copyright © All Rights Reserved {new Date().getFullYear()}{" "}
            <strong>ELEVATED IRON</strong>.
          </p>
        </div>
      </div>
    </>
  );
}

export default Footer;
